export const clone = (value) => JSON.parse(JSON.stringify(value ?? {}));

export function normalize_text(value) {
  return String(value || '').trim();
}

export function error_message(error, fallback = 'Request failed.') {
  return error?.response?.data?.message
    || error?.response?.data?.detail
    || error?.message
    || fallback;
}

export function to_number(value) {
  const normalized = Number(value);
  return Number.isFinite(normalized) && normalized > 0 ? normalized : null;
}

export function to_array(value) {
  return Array.isArray(value) ? value : [];
}

export function first_truthy(values = []) {
  return values.find((value) => value !== null && value !== undefined && value !== '') ?? null;
}

export function first_value(values = []) {
  return values.find(Boolean);
}

export function object_field(record = {}, field = '') {
  return record && typeof record === 'object' ? Reflect.get(record, field) : undefined;
}

export function path_value(record = {}, path = []) {
  return path.reduce((value, key) => object_field(value, key), record);
}

export function selected_application_id(case_code = '') {
  return application_id_from_case_code(case_code);
}

export function application_id_from_case_code(case_code = '') {
  const normalized_case_code = normalize_text(case_code);
  const direct_id = object_field(normalized_case_code.match(/^C-(\d+)$/i), 1);
  const dated_reference_id = object_field(normalized_case_code.match(/^C-\d{4}-(\d+)$/i), 1);

  return to_number(direct_id || dated_reference_id);
}

const PROJECT_SESSION_KEYS = [
  'project_id',
  'selected_project_id',
  'current_project_id',
  'active_project_id',
];

export function read_session_project_id() {
  if (typeof window === 'undefined') {
    return null;
  }

  return PROJECT_SESSION_KEYS
    .map((key) => to_number(window.sessionStorage.getItem(key)))
    .find(Boolean) || null;
}

export * from './view_case_details_answer_helpers';
export * from './view_case_details_case_fact_helpers';
export * from './view_case_details_application_helpers';
